<template>
  <div class="addAddress">
    <div class="integralBreadcrumb">
      <div @click="jumpToMy">我的</div>
      <div class="el-icon-arrow-right"></div>
      <div @click="jumpToSpareGetList">联储联备</div>
      <div class="el-icon-arrow-right"></div>
      <div @click="jumpToSpareGetList">备件领用</div>
      <div class="el-icon-arrow-right"></div>
      <div>新增收货地址</div>
    </div>
    <div class="addArea">
      <h2 class="addTitle">新增收货地址</h2>
      <div class="addInfo">
        <div class="addInfo1 addli">
          <p>
            <font color="red">*</font> 地址信息
          </p>
          <el-select v-if="provinceList"
                     v-model="selectProvince"
                     placeholder="请选择省"
                     @change="handleProvinceChoose"
                     style="margin-right: 20px;">
            <el-option v-for="(item, index) in provinceList"
                       :key="index"
                       :label="item.name"
                       :value="`${item.name}%${item.codeP}`">
            </el-option>
          </el-select>
          <el-select v-if="selectProvince"
                     v-model="selectCity"
                     placeholder="请选择市"
                     @change="handleCityChoose"
                     style="margin-right: 20px;">
            <el-option v-for="(item, index) in cityList"
                       :key="index"
                       :label="item.name"
                       :value="`${item.name}%${item.codeC}`">
            </el-option>
          </el-select>
          <el-select v-if="selectCity"
                     v-model="selectArea"
                     placeholder="请选择区"
                     @change="handleAreaChoose">
            <el-option v-for="(item, index) in areaList"
                       :key="index"
                       :label="item.name"
                       :value="`${item.name}%${item.codeA}`">
            </el-option>
          </el-select>
        </div>
        <div class="addInfo2 addli">
          <p>
            <font color="red">*</font> 详细地址
          </p>
          <input v-model.trim="reciveAddress"
                 type="text"
                 placeholder="请输入详细地址信息">
        </div>
        <div class="addInfo3 addli">
          <p>
            <font color="red">*</font> 收货人姓名
          </p>
          <input v-model.trim="reciveName"
                 type="text"
                 placeholder="请输入收货人姓名">
        </div>
        <div class="addInfo4 addli">
          <p>
            <font color="red">*</font> 手机号码
          </p>
          <input v-model.number="recivePhone"
                 type="text"
                 placeholder="请输入手机号码">
          <div style="width: 516px"></div>
          <el-checkbox v-model="defaulted"
                       text-color="#333333"
                       fill="#1D65A8"
                       class="defaultbox">
            设为默认收货地址
          </el-checkbox>
        </div>
      </div>
      <div @click="handleSaved"
           class="saveAdd">保存地址</div>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/utils/validate'
export default {
  data () {
    return {
      defaulted: false,
      recivePhone: '',
      reciveName: '',
      reciveAddress: '',
      provinceList: null,
      selectProvince: '',
      cityList: null,
      selectCity: '',
      areaList: null,
      selectArea: '',
      province: '',
      city: '',
      area: '',
      codeP: '',
      codeC: '',
      codeA: '',
      saveAddress: false
    }
  },
  mounted () {
    this.getProvince()
  },
  methods: {
    handleSaved () {
      const reg = /^((13[0-9])|(14[5,7,9])|(15[^4])|(18[0-9])|(17[0,1,2,3,5,6,7,8])|(19[8,9]))\d{8}$/
      if (this.selectArea === '') {
        this.$message.warning('请选择正确的街道信息')
      } else if (this.reciveAddress === '') {
        this.$message.warning('请输入详细地址信息')
      } else if (this.reciveName === '') {
        this.$message.warning('请输入正确的收货人姓名')
      } else if (this.recivePhone === '') {
        this.$message.warning('手机号码不能为空')
      } else if (!isMobile(this.recivePhone)) {
        this.$message.warning('请输入有效的手机号码')
      } else if (this.reciveAddress.toString().length > 50) {
        this.$message.warning('输入地址长度不能超过50位')
      } else if (this.reciveName.toString().length > 20) {
        this.$message.warning('输入姓名长度不能超过20位')
      } else {
        this.$http
          .post(
            `${window.SITE_CONFIG['forumURL']}/integral/userorderaddress/save`,
            {
              address: this.reciveAddress,
              defaultAddress: this.defaulted,
              receiveGoodsPerson: this.reciveName,
              province: this.province,
              city: this.city,
              area: this.area,
              receiveGoodsPhone: this.recivePhone
            }
          )
          .then((data) => {
            if (data.result.code === 0) {
              this.$message.success('新增成功')
              this.saveAddress = true
              // this.$router.push('/spareGetNew')
              this.$router.go(-1)
            }
          })
      }
    },
    handleProvinceChoose (value) {
      this.province = this.selectProvince.slice(
        0,
        this.selectProvince.indexOf('%')
      )
      this.codeP = this.selectProvince.slice(
        this.selectProvince.indexOf('%') + 1
      )
      this.selectCity = ''
      this.cityList = null
      this.selectArea = ''
      this.areaList = null
      this.area = ''
      this.city = ''
      this.codeC = ''
      this.codeA = ''
      this.getCity()
    },
    handleCityChoose (value) {
      this.city = this.selectCity.slice(0, this.selectCity.indexOf('%'))
      this.codeC = this.selectCity.slice(this.selectCity.indexOf('%') + 1)
      this.selectArea = ''
      this.areaList = null
      this.area = ''
      this.codeA = ''
      this.getArea()
    },
    handleAreaChoose (value) {
      this.area = this.selectArea.slice(0, this.selectArea.indexOf('%'))
      this.codeA = this.selectArea.slice(this.selectArea.indexOf('%') + 1)
    },
    jumpToMy () {
      this.$router.push('/myInfo')
    },
    jumpToSpareGetList () {
      this.$router.push('/spareGetList')
    },
    jumpToSpareGetNew () {
      this.$router.push('/spareGetNew')
    },
    getProvince () {
      this.$http.post(`/front/sys/sysProvince/queryList`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.provinceList = res.data
          }
        })
    },
    getCity () {
      this.$http.post(`/front/sys/sysCity/queryList/${this.codeP}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.cityList = res.data
          }
        })
    },
    getArea () {
      this.$http.post(`/front/sys/sysArea/queryList/${this.codeC}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.areaList = res.data
          }
        })
    }
  }
}
</script>

<style scoped>
.integralBreadcrumb {
  display: flex;
  height: 20px;
  line-height: 20px;
  margin: 20px 0;
}
.integralBreadcrumb div:nth-of-type(1) {
  font-weight: normal;
  font-size: 14px;
  color: #666666;
  user-select: none;
  cursor: pointer;
}
.integralBreadcrumb div:nth-of-type(1):hover {
  font-weight: bold;
  color: #1d65a8;
}
.integralBreadcrumb div:nth-of-type(2) {
  font-weight: normal;
  width: 26px;
  text-align: center;
  font-size: 16px;
  color: #666666;
  line-height: 20px;
  user-select: none;
}
.integralBreadcrumb div:nth-of-type(3) {
  font-weight: normal;
  font-size: 14px;
  color: #666666;
  user-select: none;
  cursor: pointer;
}
.integralBreadcrumb div:nth-of-type(3):hover {
  font-weight: bold;
  color: #1d65a8;
}
.integralBreadcrumb div:nth-of-type(4) {
  font-weight: normal;
  width: 26px;
  text-align: center;
  font-size: 16px;
  color: #666666;
  line-height: 20px;
  user-select: none;
}
.integralBreadcrumb div:nth-of-type(5) {
  font-weight: normal;
  font-size: 14px;
  color: #666666;
  user-select: none;
  cursor: pointer;
}
.integralBreadcrumb div:nth-of-type(5):hover {
  font-weight: bold;
  color: #1d65a8;
}
.integralBreadcrumb div:nth-of-type(6) {
  font-weight: normal;
  width: 26px;
  text-align: center;
  font-size: 16px;
  color: #666666;
  line-height: 20px;
  user-select: none;
}
.integralBreadcrumb div:nth-of-type(7) {
  font-weight: normal;
  font-size: 14px;
  color: #1d65a8;
  user-select: none;
}
.addAddress {
  width: 1190px;
  margin: 0 auto;
}
.addArea {
  width: 1190px;
  height: 506px;
  background: #ffffff;
  padding-left: 23px;
  padding-right: 42px;
}
.addTitle {
  height: 80px;
  line-height: 80px;
  font-size: 22px;
  color: #333333;
  text-indent: 8px;
  border-bottom: 1px solid #eeeeee;
}
.addInfo {
  height: 309px;
  padding: 40px 0;
  border-bottom: 1px solid #eeeeee;
}
.addli {
  height: 36px;
  line-height: 36px;
  display: flex;
  margin-bottom: 30px;
  color: #333333;
  font-size: 14px;
}
.addli p {
  width: 198px;
}
.addli input {
  padding-left: 10px;
}
.addInfo1 p {
  text-indent: 98px;
}
.addInfo2 p {
  text-indent: 98px;
}
.addInfo3 p {
  text-indent: 84px;
}
.addInfo4 p {
  text-indent: 98px;
}
.addInfo1 input {
  width: 436px;
}
.addInfo2 input {
  width: 811px;
}
.addInfo3 input {
  width: 160px;
}
.addInfo4 input {
  width: 160px;
}
.default {
  text-indent: 21px;
}
.saveAdd {
  width: 150px;
  height: 40px;
  background: #1d65a8;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  margin-top: 30px;
  margin-left: 859px;
  cursor: pointer;
  user-select: none;
}
</style>
